"use client";
import styles from "./page.module.scss";
import Image from "next/image";
import { Col, Modal, Pagination, Row, Skeleton } from "antd";
import * as NProgress from "nprogress";
import React, { useEffect, useState, Suspense, useMemo, memo } from "react";
import { useRouter, usePathname, useSearchParams } from "next/navigation";
import iconClock from "@/public/icon/icon-clock.svg";
import iconLocation from "@/public/icon/icon-location-circle.svg";
import iconStar from "@/public/icon/icon-start-3d.svg";
import promotionTagIcon from "@/public/icon/promotion-tag-icon.svg";
import tickIcon from "@/public/icon/tick-icon.svg";
import {
  wrapperRouterPush,
  ratingPointToText,
  convertToMillionRange,
  abbreviateName,
} from "@/src/util/util";
import ImageCommon from "@/src/component/image/image";
import { IMAGE_TYPE, PROVINCE } from "@/src/const/const";
import iconRatingStar from "@/public/icon/icon-rating-star.svg";
// import "@/src/style/common.css";
import iconCloseModal from "@/public/icon/icon-close.png";
import ChatBox from "@/src/component/detail/chatbox";
import "@/src/component/detail/detail.scss";
import {
  searchClinic,
  searchClinicByLocation,
  clinicSearchRecommend,
  getPromotion,
} from "../tim-nha-khoa/service";
import "./search-result-skeleton.scss";
import { useQuery } from "@tanstack/react-query";
import btnPromotion from "@/public/image/btn-promotion-v2.webp";
import GetCouponModal from "@/src/component/coupon/get-coupon-modal";
import useWindowSize from "@/src/hooks/useWindowSize";
import { getHeader } from "../phong-kham/[slug]/service-server";
import Link from "next/link";
import FormChatbotMobile from "@/src/component/dialog/form-chat-bot-mobile";

const options = {
  enableHighAccuracy: false, // Lower accuracy but faster response
  timeout: 2000, // Timeout after 5 seconds
  maximumAge: 60000, // Use cached location if available within 1 minute
};

const listColor = [
  "#71A3DD",
  "#71CEDD",
  "#9A92F2",
  "#FF8E75",
  "#F59B5A",
  "#DD71BF",
  "#F66565",
  "#71DDA9",
  "#A3C07E",
  "#FF7AE2",
];

function SearchResultClient({
  searchParams,
  searchResult,
  isLoading,
  suggestData,
}) {
  const router = useRouter();
  const [currentPage, setCurrentPage] = useState(1);
  const pathname = usePathname();
  const searchParamUrl = useSearchParams();
  const [openModal, setOpenModal] = useState(false);
  const [dataModal, setDataModal] = useState(null);
  const [openCouponModal, setOpenCouponModal] = useState(false);
  const date = new Date();
  const params = new URLSearchParams(searchParams);
  function getRandomElements(arr, count) {
    const shuffled = arr?.sort(() => 0.5 - Math.random());
    return shuffled?.slice(0, count);
  }
  const [openModalChatbotMobile, setOpenModalChatbotMobile] = useState(false);
  const [clinicDetail, setClinicDetail] = useState(null);

  const backgroundColor = () => {
    return listColor[Math.floor(Math.random() * listColor.length)];
  };

  const backgroundColorMemo = useMemo(
    () => backgroundColor(),
    [listColor.length]
  );

  useEffect(() => {
    if (openModal) {
      document.body.classList.add("modal-open");
    } else {
      document.body.classList.remove("modal-open");
    }
    return () => {
      document.body.classList.remove("modal-open");
    };
  }, [openModal]);
  useEffect(() => {
    if (searchParams.page) {
      if (parseInt(searchParams.page) > 5) setCurrentPage(5);
      else setCurrentPage(parseInt(searchParams.page));
    } else setCurrentPage(1);
  }, [pathname, searchParamUrl]);
  const onChangePage = (page) => {
    const newSearchParams = {};
    if (searchParams.hasOwnProperty("lon")) {
      newSearchParams.lon = searchParams.lon;
    }
    if (searchParams.hasOwnProperty("lat")) {
      newSearchParams.lat = searchParams.lat;
    }
    if (searchParams.hasOwnProperty("weekday")) {
      newSearchParams.weekday = searchParams.weekday;
    }
    if (searchParams.hasOwnProperty("time")) {
      newSearchParams.time = searchParams.time;
    }
    if (searchParams.hasOwnProperty("min")) {
      newSearchParams.min = searchParams.min;
    }
    if (searchParams.hasOwnProperty("max")) {
      newSearchParams.max = searchParams.max;
    }
    if (searchParams.hasOwnProperty("name")) {
      newSearchParams.name = searchParams.name;
    }
    if (searchParams.hasOwnProperty("district")) {
      newSearchParams.district = searchParams.district;
    }
    newSearchParams.page = page;

    const param = new URLSearchParams(newSearchParams).toString();

    NProgress.start();
    router.push(`${pathname}?${param}`);
  };

  const onShowDetail = (slug) => {
    router.query = {
      service_name: searchParams?.category_service_name,
      service_slug: searchParams?.category_service_slug,
    };
    wrapperRouterPush(router, `/phong-kham/${slug}`);
  };

  // const ramdomSuggestData = useMemo(
  //   () => getRandomElements(suggestData?.data, 10),
  //   [suggestData?.data?.length]
  // );
  const ramdomSuggestData = suggestData?.data;
  console.log("ramdomSuggestData", suggestData?.data);

  return (
    <div className="wp-search-result">
      <div className={styles.wpResult}>
        {!searchResult?.data?.length > 0 && (
          <div
            style={{
              color: "#2a3467",
              display: "flex",
              justifyContent: "center",
              fontSize: "16px",
              margin: "12px 0px",
            }}
          >
            Không có kết quả tìm kiếm
          </div>
        )}
        {searchResult &&
          searchResult?.data &&
          searchResult?.data.map((item) => {
            // const cover = item?.image?.find(
            //   (sitem) => sitem?.image_type == IMAGE_TYPE.banner
            // );
            const validContract = item?.user?.user_agreements?.length > 0;
            const logo = item?.image?.find(
              (sitem) => sitem?.image_type == IMAGE_TYPE.avatar
            );

            if (item?.isPromotion) {
              const imageMobile = item?.image?.find(
                (si) => si?.image_type == "PROMOTION_MOBILE"
              );
              const imageDesktop = item?.image?.find(
                (si) => si?.image_type == "PROMOTION_DESKTOP"
              );
              return (
                <Link href={item?.post_link}>
                  <div className={styles.itemPromotion}>
                    <ImageCommon
                      data={imageDesktop}
                      alt="promotion"
                      style={`${styles.itemImage} ${styles.itemImageDesktop} block-animation-darker`}
                    />
                    <ImageCommon
                      data={imageMobile}
                      alt="promotion"
                      style={`${styles.itemImage} ${styles.itemImageMobile} block-animation-darker`}
                    />
                    <div className={styles.tagTitlePromotion}>Quảng cáo</div>
                  </div>
                </Link>
              );
            }
            return (
              // <>
              //   {!isLoading ? (
              <div
                key={item?.id}
                className={`${styles.itemResult} block-animation-darker`}
                onClick={() => onShowDetail(item?.slug)}
              >
                {/* <ImageCommon data={cover} style={styles.cover} /> */}
                {validContract && (
                  <div className={styles.tagTitle}>Khuyến Mãi</div>
                )}
                <div className={styles.wpInfo}>
                  <div className={styles.wpFirstLine}>
                    <div className={styles.wpContainerAbove}>
                      <div className={styles.wpLeft}>
                        <ImageCommon data={logo} style={styles.logo} />
                      </div>
                      <div className={styles.wpRight}>
                        <div className={styles.titleClinic}>
                          <Link href={"/phong-kham/" + item?.slug}>
                            <h2 className={styles.titleClinic}>{item?.name}</h2>
                          </Link>
                          <div
                            className={`${styles.buttonAdvise} button-blue`}
                            onClick={(e) => {
                              setDataModal(item);
                              setOpenModal(true);
                              e.stopPropagation();
                              setOpenModal(true);
                            }}
                          >
                            Đặt lịch giữ chỗ
                          </div>
                        </div>
                        {item?.address?.length > 0 && (
                          <div className={styles.firstLineTag}>
                            <div className={styles.wpTagInfo}>
                              <Image
                                src={iconLocation}
                                className={styles.iconLocation}
                                alt="Location icon"
                              />
                              {item.address[0]}
                            </div>
                            {/* {validContract && (
                              <Image
                                src={btnPromotion}
                                // onClick={(e) => {
                                //   e.stopPropagation();
                                //   setOpenCouponModal(true);
                                // }}
                                className={styles.couponButton}
                                alt="promotion button"
                              ></Image>
                            )} */}
                            <div
                              className={`${styles.buttonAdvise} ${styles.buttonAdviseSecond} button-red`}
                              onClick={(e) => {
                                e.stopPropagation();
                                setOpenModalChatbotMobile(true);
                                setClinicDetail(item);
                              }}
                            >
                              Nhận tư vấn
                            </div>
                          </div>
                        )}

                        <div className={styles.wpRatingLine}>
                          {item?.rating_overview?.overall_average ? (
                            <div className={styles.wpRatingInLine}>
                              <div className={styles.ratingPoint}>
                                <div className={styles.point}>
                                  {item?.rating_overview?.overall_average.toFixed(
                                    1
                                  )}
                                </div>
                                <Image
                                  className={styles.iconRatingStar}
                                  src={iconStar}
                                  alt="icon"
                                />
                              </div>
                              <div className={styles.dash}></div>
                            </div>
                          ) : null}
                          <div
                            style={{
                              display: "flex",
                              alignItems: "center",
                            }}
                          >
                            <div className={styles.ratingQuantity}>
                              {item?.rating_overview?.number_of_ratings} Đánh
                              giá
                            </div>
                            <div className={styles.dash}></div>
                            <div className={styles.numberOfConsultation}>
                              {item?.total_contact ? item?.total_contact : 0}{" "}
                              Người đặt lịch
                            </div>
                          </div>
                        </div>
                        {item?.promotion_text?.length > 0 &&
                          item?.promotion_text[0] && (
                            <div className={styles.wpPromotionText}>
                              {item?.promotion_text[0]
                                ?.split(/\s*[;]\s*/)
                                ?.map((item) => {
                                  return (
                                    <div className={styles.promotionItem}>
                                      <Image
                                        src={promotionTagIcon}
                                        alt="promotionTagIcon"
                                        width={16}
                                        height={16}
                                        className={styles.promotionTagIcon}
                                      ></Image>
                                      {item}
                                    </div>
                                  );
                                })}
                            </div>
                          )}
                        {item?.tag_clinic?.length > 0 && (
                          <div className={styles.wpUtilities}>
                            {item?.tag_clinic?.map((item) => {
                              return (
                                <div className={styles.utilitiesItem}>
                                  <Image
                                    src={tickIcon}
                                    alt="tickIcon"
                                    width={14}
                                    height={14}
                                    className={styles.tickIcon}
                                  ></Image>
                                  {item?.tag?.name}
                                </div>
                              );
                            })}
                          </div>
                        )}
                      </div>
                      {item?.distance && (
                        <div className={styles.distance}>
                          {(item.distance / 1000)?.toFixed(1)}km
                        </div>
                      )}
                    </div>
                    {/*Block đánh giá*/}
                    {item?.rating && item?.rating?.length > 0 && (
                      <div className={styles.wpRating}>
                        {item.rating[0]?.user?.image?.length > 0 &&
                        item.rating[0]?.user?.image[0]?.key ? (
                          <ImageCommon
                            data={item.rating[0].user.image[0]}
                            style={styles.avatarUser}
                          />
                        ) : (
                          <div
                            className={styles.avatarRandom}
                            style={{ backgroundColor: backgroundColorMemo }}
                          >
                            {abbreviateName(
                              item.rating[0].user?.name
                                ? item.rating[0].user?.name
                                : item.rating[0]?.user_name
                            )}
                          </div>
                        )}
                        <span style={{ display: "flex", alignItems: "center" }}>
                          " {item.rating[0].content} "
                        </span>
                      </div>
                    )}
                    <div className={styles.listPrice}>
                      {item.service?.map((serviceValue) => {
                        const isShowService =
                          serviceValue.category_service.id ===
                            searchParams.category_service &&
                          serviceValue.service;

                        return (
                          isShowService &&
                          isShowService?.length > 0 && (
                            <div className={styles.wpList}>
                              {serviceValue.service
                                ?.slice(0, 4)
                                .map((serviceItem, index) => {
                                  if (serviceItem.name) {
                                    return (
                                      <>
                                        {(index == 1 || index == 3) && (
                                          <div
                                            className={styles.dashPriceList}
                                          ></div>
                                        )}
                                        <div className={styles.priceItem}>
                                          <div className={styles.firstColumn}>
                                            <div
                                              className={styles.priceItemName}
                                            >
                                              {serviceItem.name}
                                            </div>
                                          </div>
                                          <div className={styles.secondColumn}>
                                            {
                                              <div
                                                className={
                                                  styles.priceItemAmount
                                                }
                                              >
                                                {convertToMillionRange(
                                                  serviceItem?.amount,
                                                  serviceItem?.amount_max
                                                )}
                                              </div>
                                            }
                                          </div>
                                        </div>
                                      </>
                                    );
                                  }
                                })}
                            </div>
                          )
                        );
                      })}
                    </div>{" "}
                    {!searchParams.category_service &&
                      item.service?.length > 0 && <PriceService item={item} />}
                    <div className={styles.thirdLineTag}>
                      <div className={`${styles.buttonDetail} button-white`}>
                        Xem chi tiết
                      </div>
                      <div
                        className={`${styles.buttonAdvise} button-blue`}
                        onClick={(e) => {
                          e.stopPropagation();
                          setDataModal(item);
                          setOpenModal(true);
                        }}
                      >
                        Đặt lịch giữ chỗ
                      </div>
                      {/* {validContract && (
                        <Image
                          src={btnPromotion}
                          // onClick={(e) => {
                          //   e.stopPropagation();
                          //   setOpenCouponModal(true);
                          // }}
                          className={styles.couponButton}
                          alt="promotion button"
                        />
                      )} */}
                      <div
                        className={`${styles.buttonAdvise} ${styles.buttonAdviseSecond} button-red`}
                        onClick={(e) => {
                          e.stopPropagation();
                          setOpenModalChatbotMobile(true);
                          setClinicDetail(item);
                        }}
                      >
                        Nhận tư vấn
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              //   ) : (
              //     <div className="wpSkeletonItemClinic">
              //       {/* <Skeleton.Image className="skeletonImage" active /> */}
              //       <Skeleton.Input className="skeletonItem" active />
              //     </div>
              //   )}
              // </>
            );
          })}
      </div>
      {searchResult?.count > 10 && (
        <Pagination
          // onChange={onChangePage}
          // defaultCurrent={1}
          current={currentPage}
          rel
          total={searchResult?.count < 50 ? searchResult?.count : 50}
          showSizeChanger={false}
          className="pagination"
          style={{ marginBottom: "64px" }}
          itemRender={(page, type, defaultItem) => {
            params.delete("page");
            params.delete("district_id");
            params.delete("province_id");
            params.delete("category_service");
            params.delete("district_name");
            params.delete("province_name");
            params.delete("category_service_name");
            params.delete("district_slug");
            params.delete("province_slug");
            params.delete("category_service_slug");
            const queryString = params.toString();
            if (type == "page")
              return (
                <Link
                  href={`${pathname}?${
                    queryString ? `${queryString}&` : ""
                  }page=${page}`}
                >
                  {page}
                </Link>
              );
            return defaultItem;
          }}
        />
      )}
      {ramdomSuggestData && ramdomSuggestData?.length > 0 && (
        <div className={styles.wpResult}>
          <div className={styles.suggestText}>Có thể bạn quan tâm</div>
          {ramdomSuggestData?.map((item) => {
            const logo = item?.image?.find(
              (sitem) => sitem?.image_type == IMAGE_TYPE.avatar
            );
            return (
              <>
                {!isLoading ? (
                  <div
                    key={item?.id}
                    className={`${styles.itemResult} block-animation-darker`}
                    onClick={() => onShowDetail(item?.slug)}
                  >
                    {/* {item?.distance && (
                      <div className={styles.distance}>
                        {(item.distance / 1000)?.toFixed(1)}km
                      </div>
                    )} */}
                    <div className={styles.wpInfo}>
                      <div className={styles.wpFirstLine}>
                        <div className={styles.wpContainerAbove}>
                          <div className={styles.wpLeft}>
                            <ImageCommon data={logo} style={styles.logo} />
                          </div>
                          <div className={styles.wpRight}>
                            <div className={styles.titleClinic}>
                              <Link href={"/phong-kham/" + item?.slug}>
                                <h2 className={styles.titleClinic}>
                                  {item?.name}
                                </h2>
                              </Link>

                              <div
                                className={`${styles.buttonAdvise} button-blue`}
                                onClick={(e) => {
                                  setDataModal(item);
                                  setOpenModal(true);
                                  e.stopPropagation();
                                }}
                              >
                                Đặt lịch giữ chỗ
                              </div>
                            </div>
                            <div className={styles.firstLineTag}>
                              {item?.address?.length > 0 ? (
                                <div className={styles.wpTagInfo}>
                                  <Image
                                    src={iconLocation}
                                    className={styles.iconLocation}
                                    alt="Location icon"
                                  />
                                  {item.address[0]}
                                </div>
                              ) : null}
                              <div
                                className={`${styles.buttonAdvise} ${styles.buttonAdviseSecond} button-red`}
                                onClick={(e) => {
                                  e.stopPropagation();
                                  setOpenModalChatbotMobile(true);
                                  setClinicDetail(item);
                                }}
                              >
                                Nhận tư vấn
                              </div>
                            </div>
                            <div className={styles.wpRatingLine}>
                              {item?.rating_overview?.overall_average ? (
                                <div className={styles.wpRatingInLine}>
                                  <div className={styles.ratingPoint}>
                                    <div className={styles.point}>
                                      {item?.rating_overview?.overall_average.toFixed(
                                        1
                                      )}
                                    </div>
                                    <Image
                                      className={styles.iconRatingStar}
                                      src={iconStar}
                                      alt="icon"
                                    />
                                  </div>
                                  <div className={styles.dash}></div>
                                </div>
                              ) : null}
                              <div
                                style={{
                                  display: "flex",
                                  alignItems: "center",
                                }}
                              >
                                <div className={styles.ratingQuantity}>
                                  {item?.rating_overview?.number_of_ratings}{" "}
                                  Đánh giá
                                </div>
                                <div className={styles.dash}></div>
                                <div className={styles.numberOfConsultation}>
                                  {item?.total_contact
                                    ? item?.total_contact
                                    : 0}{" "}
                                  Người đặt lịch
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                        {item?.rating && item?.rating?.length > 0 && (
                          <div className={styles.wpRating}>
                            {item.rating[0]?.user?.image?.length > 0 &&
                            item.rating[0]?.user?.image[0]?.key ? (
                              <ImageCommon
                                data={item.rating[0].user.image[0]}
                                style={styles.avatarUser}
                              />
                            ) : (
                              <div
                                className={styles.avatarRandom}
                                style={{ backgroundColor: backgroundColorMemo }}
                              >
                                {abbreviateName(
                                  item.rating[0].user?.name
                                    ? item.rating[0].user?.name
                                    : item.rating[0]?.user_name
                                )}
                              </div>
                            )}
                            <span
                              style={{ display: "flex", alignItems: "center" }}
                            >
                              " {item.rating[0].content} "
                            </span>
                          </div>
                        )}
                        <div className={styles.listPrice}>
                          {item?.service?.map((serviceValue) => {
                            const isShowService =
                              serviceValue.category_service.id ===
                                searchParams.category_service &&
                              serviceValue.service;

                            return (
                              isShowService &&
                              isShowService?.length > 0 && (
                                <div className={styles.wpList}>
                                  {serviceValue.service
                                    ?.slice(0, 4)
                                    .map((serviceItem, index) => {
                                      if (serviceItem.name) {
                                        return (
                                          <>
                                            {(index == 1 || index == 3) && (
                                              <div
                                                className={styles.dashPriceList}
                                              ></div>
                                            )}
                                            <div className={styles.priceItem}>
                                              <div
                                                className={styles.firstColumn}
                                              >
                                                <div
                                                  className={
                                                    styles.priceItemName
                                                  }
                                                >
                                                  {serviceItem.name}
                                                </div>
                                                {/* {serviceItem.unit && (
                                                <div
                                                  className={
                                                    styles.priceGuarantee
                                                  }
                                                >{`Đơn vị: ${serviceItem.unit}`}</div>
                                              )} */}
                                              </div>
                                              <div
                                                className={styles.secondColumn}
                                              >
                                                {
                                                  <div
                                                    className={
                                                      styles.priceItemAmount
                                                    }
                                                  >
                                                    {convertToMillionRange(
                                                      serviceItem?.amount,
                                                      serviceItem?.amount_max
                                                    )}
                                                  </div>
                                                }
                                                {/* {serviceItem?.guarantee && (
                                                <div
                                                  className={
                                                    styles.priceGuarantee
                                                  }
                                                >{`Bảo hành: ${serviceItem.guarantee}`}</div>
                                              )} */}
                                              </div>
                                            </div>
                                          </>
                                        );
                                      }
                                    })}
                                </div>
                              )
                            );
                          })}
                        </div>{" "}
                        {!searchParams.category_service &&
                          item?.service.length > 0 && (
                            <PriceService item={item} />
                          )}
                        <div className={styles.thirdLineTag}>
                          <div
                            className={`${styles.buttonDetail} button-white`}
                          >
                            Xem chi tiết
                          </div>
                          <div
                            className={`${styles.buttonAdvise} button-blue`}
                            onClick={(e) => {
                              e.stopPropagation();
                              setDataModal(item);
                              setOpenModal(true);
                            }}
                          >
                            Đặt lịch giữ chỗ
                          </div>
                          <div
                            className={`${styles.buttonAdvise} ${styles.buttonAdviseSecond} button-red`}
                            onClick={(e) => {
                              e.stopPropagation();
                              setOpenModalChatbotMobile(true);
                              setClinicDetail(item);
                            }}
                          >
                            Nhận tư vấn
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                ) : (
                  <div className="wpSkeletonItemClinic">
                    <Skeleton.Input className="skeletonItem" active />
                  </div>
                )}
              </>
            );
          })}
        </div>
      )}
      <GetCouponModal
        setIsModalOpen={setOpenCouponModal}
        isModalOpen={openCouponModal}
      />
      <Modal
        className="wpModalChatBox"
        open={openModal}
        footer={null}
        closable={true}
        width={380}
        centered
        style={{ top: 10 }}
        destroyOnClose={true}
        onCancel={() => {
          setOpenModal(false);
        }}
      >
        <div style={{ position: "relative" }}>
          <ChatBox detailClinic={dataModal} isModal={true} />
          <div
            className="closeModal"
            onClick={() => {
              setOpenModal(false);
            }}
          >
            <Image src={iconCloseModal} alt="Close modal icon" />
          </div>
        </div>
      </Modal>
      <Modal
        className="modal-chatbot-mobile"
        open={openModalChatbotMobile}
        onCancel={() => {
          setOpenModalChatbotMobile(false);
        }}
        footer={null}
        closable={true}
        width={380}
        destroyOnClose={true}
        centered
      >
        <FormChatbotMobile clinic={clinicDetail} />
      </Modal>
    </div>
  );
}

const PriceService = memo((props) => {
  const { width } = useWindowSize();
  const prioritizedServices = [
    "Niềng răng",
    "Trồng răng Implant",
    "Bọc răng sứ",
    "Nhổ răng khôn",
    "Răng giả tháo lắp",
    "Trám răng",
  ];
  let newArrPriority = [];
  let newArrNotPriority = [];
  props.item.service.forEach((curr) => {
    if (curr.service.length > 0) {
      const serviceName = curr.category_service.name;
      const priorityIndex = prioritizedServices.indexOf(serviceName);
      if (priorityIndex !== -1) {
        newArrPriority[priorityIndex] = curr;
      } else {
        newArrNotPriority.push(curr);
      }
    }
  });
  const arrService = [...newArrPriority.filter(Boolean), ...newArrNotPriority];
  if (arrService.length > 0) {
    return (
      <div key={props.item.id}>
        <div className={styles.listPrice}>
          <Row className={`${styles.wpList} wp-list-price`}>
            {arrService.slice(0, 6).map((serviceValue, index) => {
              const hideDashPrice = (() => {
                return width >= 992
                  ? index === 2 || index === 5
                  : width >= 576
                  ? index % 2 === 1
                  : true;
              })();

              const minAmount = Math.min(
                ...serviceValue.service.map((service) => service.amount)
              );
              const maxAmountMax = Math.max(
                ...serviceValue.service.map((service) => service.amount_max)
              );

              return (
                <Col
                  xs={24}
                  sm={12}
                  lg={8}
                  className={styles.priceItem}
                  key={index}
                >
                  <div className={styles.firstColumn}>
                    <div className={styles.priceItemName}>
                      {serviceValue.category_service.name}
                    </div>
                  </div>
                  <div className={styles.secondColumn}>
                    <div className={styles.priceItemAmount}>
                      {convertToMillionRange(minAmount, maxAmountMax)}
                    </div>
                  </div>
                  {!hideDashPrice && <div className={styles.dashPrice} />}
                </Col>
              );
            })}
          </Row>
        </div>
      </div>
    );
  }
});

function SearchResult({ searchParams, searchResult }) {
  // let res = null;
  const emptyArray = Array.from({ length: 5 });
  const initalData = {
    count: 5,
    data: emptyArray,
    inital: true,
  };
  // const [searchResult, setSearchResult] = useState(initalData);
  const [suggestData, setSuggestData] = useState(initalData);
  const [isLoading, setIsLoading] = useState(true);
  const [promotion, setPromotion] = useState(null);
  useEffect(() => {
    (async () => {
      if (searchParams?.province_id) {
        const promo = await getPromotion(searchParams?.province_id);
        setPromotion(promo.data);
        if (searchResult?.count < 5) {
          const listClinicsExcept =
            searchResult.data?.map((item) => item.id) || [];
          const province = PROVINCE.find(
            (prov) => prov.id == searchParams?.province_id
          );
          const suggestions = await clinicSearchRecommend(
            province.lon,
            province.lat,
            searchParams?.province_id,
            searchParams?.district_id,
            listClinicsExcept
          );
          setSuggestData(suggestions.data);
        } else {
          setSuggestData(null);
        }
      } else {
        setSuggestData(null);
      }
      setIsLoading(false);
    })();
  }, [searchParams]);

  const mergedResult = useMemo(() => {
    if (searchResult?.count == 0) return searchResult;

    let dataResult = [...searchResult?.data];
    if (promotion) {
      if (dataResult.length > 2)
        dataResult.splice(2, 0, { ...promotion, isPromotion: true });
      if (dataResult.length > 6)
        dataResult.splice(6, 0, { ...promotion, isPromotion: true });
    }

    return {
      ...searchResult,
      data: dataResult,
    };
  }, [searchResult, promotion]);

  return (
    <Suspense>
      <SearchResultClient
        searchParams={searchParams}
        searchResult={mergedResult}
        suggestData={suggestData}
        isLoading={isLoading}
        promotion={promotion}
      />
    </Suspense>
  );
}
const MemoizedSearchResult = SearchResult;
export default MemoizedSearchResult;
